import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import MarketPlace from "../components/MarketPlace";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const MarketPlacePage = () => {
  return (
    <>
      <Helmet>
        <title>Marketplace | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Discover TimeWatch Infocom’s Marketplace, offering a wide range of advanced biometric solutions, access control systems, time attendance devices, entrance automation, and parking management technologies. Shop the latest security products designed for businesses, organizations, and enterprises seeking innovative and reliable security solutions. Our marketplace features top-quality, smart security technology tailored to meet your unique needs. Explore the best in security technology and invest in cutting-edge systems that ensure safety, efficiency, and convenience for your operations."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/market-place"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="marketplace">
          <MarketPlace />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default MarketPlacePage;
